<!-- 商品详情 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
		</div>

		<div class="banner-box">
			<img src="../assets/img.png" class="banner-img">
			<div class="diandian">
				1/5
			</div>
		</div>

		<div class="padding-box">
			<div class="msg-box">
				<p class="price">
					¥<span>344</span>
				</p>
				<div class="row-between">
					<p class="name">AP AUTOSAR 开发板</p>
					<button type="button" class="share-btn">
						<img src="../assets/icon-29.png">
						分享
					</button>
				</div>
			</div>

			<div class="select-box">
				<span class="select-box-label">选择</span>
				<div class="select-row">
					<span class="select-name">【奥利奥&樱花】随机发货</span>
					<img src="../assets/back-icon3.png" class="back-icon">
				</div>
			</div>
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<div class="footer-sidebar">
					<button type="button" @click="$router.push('/product-customer-service')">
						<img src="../assets/details-1.png">客服
					</button>
					<button type="button">
						<img src="../assets/details-2.png">收藏
					</button>
					<button type="button" @click="$router.push('/product-address-shopping-cart')">
						<img src="../assets/details-3.png">购物车
					</button>
				</div>
				<div class="btn-box">
					<button type="button" @click="showAddCart = true">加入购物车</button>
					<button type="button" @click="$router.push('/product-confirm-order')">立即购买</button>
				</div>
			</div>
		</div>

		<!-- 加入购物车弹窗 -->
		<van-overlay :show="showAddCart" z-index="99999">
			<div class="mask-layer" @click="showAddCart = false"></div>
			<div class="add-cart-window">
				<div class="add-cart-module">
					<img src="../assets/img.png" class="add-cart-module-img">
					<div class="add-cart-module-sidebar">
						<div class="add-cart-price-wrap">
							<p class="add-cart-price">¥<span>344</span></p>
							-
							<p class="add-cart-price">¥<span>899</span></p>
						</div>
						<p class="msg-row">
							<!-- 未选择显示 -->
							<span class="gray">请选择</span>
							<!-- 已选择显示 -->
							<span class="gray">已选择<span class="blue">KIT_TPC7908 不开发票</span></span>
						</p>
					</div>
				</div>
				<div class="add-cart-box">
					<p class="add-cart-module-label">类型</p>
					<ul class="add-cart-module-list">
						<li class="active">KIT_TPC7908</li>
						<li>KIT_TPC7908</li>
						<li>KIT_TPC7908</li>
						<li>KIT_TPC7908</li>
						<li>KIT_TPC7908</li>
					</ul>
				</div>
				<div class="add-cart-box">
					<p class="add-cart-module-label">发票</p>
					<ul class="add-cart-module-list">
						<li class="active">不开发票 </li>
						<li>开发票 </li>
					</ul>
				</div>
				<div class="purchase-quantity">
					<span class="purchase-quantity-label">购买数量</span>
					<div class="calc-wrap">
						<button type="button"><img src="../assets/calc-less.png"></button>
						<input type="" name="" id="" value="1" />
						<button type="button"><img src="../assets/calc-add.png"></button>
					</div>
				</div>
				<div class="add-cart-btn-box">
					<button type="button">加入购物车</button>
					<button type="button">立即购买</button>
				</div>
			</div>
		</van-overlay>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				showAddCart: false
			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0);
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.banner-box {
		width: 100%;
		position: relative;
	}

	.banner-img {
		width: 100%;
		height: 340px;
	}

	.diandian {
		position: absolute;
		right: 15px;
		bottom: 14px;
		background: #000;
		border-radius: 30px;
		width: 40px;
		height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		color: #FFFFFF;
	}

	.padding-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.msg-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 12px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		margin-bottom: 10px;
		padding: 10px;
		box-sizing: border-box;
	}

	.price {
		font-size: 14px;
		color: #FF4954;
		font-weight: bold;
		margin-bottom: 3px;
	}

	.price>span {
		font-size: 24px;
	}

	.row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.name {
		color: #222222;
		font-size: 18px;
		font-weight: bold;
	}

	.share-btn {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #222222;
		font-size: 9px;
	}

	.share-btn>img {
		width: 16px;
		margin-bottom: 2px;
	}

	.select-box {
		width: 100%;
		height: 52px;
		line-height: 52px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 12px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
	}

	.select-box-label {
		color: #666666;
		font-size: 13px;
		margin-right: 10px;
	}

	.select-row {
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.select-name {
		color: #222222;
		font-size: 14px;
	}

	.back-icon {
		width: 5px;
	}

	.footer {
		width: 100%;
		height: 83px;
		display: flex;
		align-items: flex-start;
		background-color: #FFFFFF;
		padding: 8px 0 0;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 199;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.footer-sidebar {
		display: flex;
		align-items: flex-end;
		padding-right: 15px;
	}

	.footer-sidebar>button {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 10px;
		margin-right: 30px;
	}

	.footer-sidebar>button:last-child {
		margin-right: 0;
	}

	.footer-sidebar>button>img {
		height: 18px;
		margin-bottom: 1px;
	}

	.btn-box {
		flex: 1;
		height: 32px;
		display: flex;
		align-items: center;
		overflow: hidden;
	}

	.btn-box>button {
		flex: 1;
		height: 100%;
		color: #FFFFFF;
		font-size: 14px;
		background-color: #FFAF18;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}

	.btn-box>button:last-child {
		background-color: #2A63F3;
		margin-right: 0;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background: rgba(0, 0, 0, 0.5);
	}

	.add-cart-window {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #FFFFFF;
		border-radius: 16px 16px 0 0;
		display: flex;
		flex-direction: column;
		z-index: 505;
		padding: 20px 15px 0;
		box-sizing: border-box;
	}

	.add-cart-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 33px 0 43px;
		border-radius: 100px;
		overflow: hidden;
	}

	.add-cart-btn-box>button {
		flex: 1;
		height: 32px;
		line-height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFAF18;
		color: #FFFFFF;
		font-size: 14px;
		font-weight: bold;
	}

	.add-cart-btn-box>button:last-child {
		background-color: #2A63F3;
	}

	.add-cart-module {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.add-cart-module-img {
		width: 70px;
		height: 70px;
		border-radius: 12px;
		margin-right: 10px;
	}

	.add-cart-module-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.add-cart-price-wrap {
		display: flex;
		align-items: center;
		color: #FF4954;
		font-size: 24px;
	}

	.add-cart-price {
		font-size: 14px;
		font-weight: bold;
		color: #FF4954;
	}

	.add-cart-price>span {
		font-size: 24px;
	}

	.msg-row {
		margin-top: 9px;
	}

	.gray {
		color: #999999;
		font-size: 14px;
	}

	.blue {
		margin-left: 2px;
		color: #2A63F3;
		font-size: 14px;
	}

	.add-cart-box {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.add-cart-module-label {
		width: 100%;
		color: #222222;
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.add-cart-module-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 6px;
	}

	.add-cart-module-list>li {
		color: #222222;
		font-size: 11px;
		height: 26px;
		line-height: 26px;
		width: fit-content;
		padding: 0 16px;
		background-color: #F3F3F3;
		border-radius: 30px;
		display: flex;
		align-items: center;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.add-cart-module-list>li.active {
		color: #2A63F3;
		border: 1px solid #2A63F3;
		background-color: #F4F8FF;
	}

	.purchase-quantity {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 1px solid #F2F2F2;
		padding: 15px 0;
		box-sizing: border-box;
	}

	.purchase-quantity-label {
		font-size: 13px;
		color: #222222;
	}

	.calc-wrap {
		display: flex;
		align-items: center;
	}

	.calc-wrap>button {
		display: flex;
		align-items: center;
	}

	.calc-wrap>button>img {
		width: 20px;
		height: 20px;
	}

	.calc-wrap>input {
		width: 29px;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #222222;
		text-align: center;
	}
</style>
